export enum ResponseMappingActionsEnum {
  TAG = 'tag',
  UNTAG = 'untag',
  SAVE_TO_FIELD = 'save_field',
  ASSIGN_DEPARTMENT = 'assign_department',
  SUBSCRIBE = 'subscribe',
  UNSUBSCRIBE = 'unsubscribe',
}
